import React, { useEffect, useState } from "react";
import SidebarFilters from "../components/investorDashboard/SidebarFilters";
import CompanyTable from "../components/investorDashboard/CompanyTable";
import SearchHeader from "../components/investorDashboard/SearchHeader";
import { Company } from "../types/investorDashboardTypes";
import Navbar from "../components/shared/Navbar";
import axios from "axios";
import TopFilters from "../components/investorDashboard/SidebarFilters";
import TableWithTopScroll from "../components/investorDashboard/TableWithTopScroll"
import {Theme} from "../lib/theme"

const fetchCompanies = async (
  start: number,
  limit: number
): Promise<Company[]> => {
  const res = await axios.post("http://localhost:5000/api/investor-portal", {
    start,
    limit,
  });

  return res.data.data;
};

const ITEMS_PER_PAGE = 50;

const Dashboard: React.FC = () => {
  
  const [loading, setLoading] = useState<boolean>(false);
  const [investorTypes, setInvestorTypes] = useState<string[]>([]);
  const [countries, setCountries] = useState<string[]>([]);
  const toggleSelection = (list: string[], value: string): string[] =>
    list.includes(value)
      ? list.filter((item) => item !== value)
      : [...list, value];

  const [paginatedData, setPaginatedData] = useState<Company[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(100);
  const [isFiltered, setIsFiltered] = useState(false);
  const [filters, setFilters] = useState({
    investor_types: [] as string[],
    countries: [] as string[],
    industries: [] as string[],
    search: "",
  });
  const [debouncedSearch, setDebouncedSearch] = useState(filters.search);
  const [isExporting, setIsExporting] = useState(false);

  const handleInvestorChange = (types: string[]) =>
    setFilters((prev) => ({ ...prev, investor_types: types }));

  const handleCountryChange = (countries: string[]) =>
    setFilters((prev) => ({ ...prev, countries }));

  const handleSearchChange = (val: string) =>
    setFilters((prev) => ({ ...prev, search: val }));

 

 const handleExport = async () => {
  setIsExporting(true);

  try {
    const response = await fetch("https://dtv1hsy3xhnbw.cloudfront.net/api/export-investors", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ filters: filters }), 
    });

    if (!response.ok) {
      throw new Error("Failed to export data");
    }

    // Create a Blob and download it
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "filtered_investors.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Export failed:", error);
    alert("Export failed. Please try again.");
  } finally {
    setIsExporting(false); 
  }
};


  const loadCompanies = async (start: number, method = "read") => {
    setLoading(true);
    try {
      const payload = isFiltered
        ? {
            method: "filter",
            start,
            limit: ITEMS_PER_PAGE,
            filters,
          }
        : {
            method: "read",
            start,
            limit: ITEMS_PER_PAGE,
          };

      const res = await axios.post(
        "https://dtv1hsy3xhnbw.cloudfront.net/api/investor-portal",
        payload
      );
      const records = res.data;
      console.log("---------------", records, records["records"], res.data);
      setPaginatedData(records["records"]);

      setPaginatedData(records["records"]);
      setTotalPages(Math.ceil(res.data.total / ITEMS_PER_PAGE));
    } catch (err) {
      console.error("Error loading companies", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedSearch(filters.search);
  }, 500);

  return () => clearTimeout(timer);
}, [filters.search]);
 useEffect(() => {
  const start = (currentPage - 1) * ITEMS_PER_PAGE;

  if (debouncedSearch.trim()) {
    setIsFiltered(true);
    loadCompanies(start, "filter");
  } else {
    loadCompanies(start, isFiltered ? "filter" : "read");
  }
}, [currentPage, debouncedSearch,isFiltered]);


  return (
    <div>
      <Navbar />
      <div className="flex min-h-screen">
        {/* <SidebarFilters
          selectedInvestorTypes={investorTypes}
          selectedCountries={countries}
          onInvestorChange={(type) =>
            setInvestorTypes(toggleSelection(investorTypes, type))
          }
          onCountryChange={(country) =>
            setCountries(toggleSelection(countries, country))
          }
        /> */}
        <main className="flex-1 p-6 overflow-x-auto">
          <SearchHeader
            search={filters.search}
            onSearchChange={handleSearchChange}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            onExport={handleExport}
          />
          <TopFilters
            selectedInvestorTypes={filters.investor_types}
            selectedCountries={filters.countries}
            onInvestorChange={handleInvestorChange}
            onCountryChange={handleCountryChange}
          />
          {loading ? (
            <div className="flex items-center justify-center mt-2">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
            </div>
          ) : (
            <div className="flex items-center justify-between w-[100%] min-h[30px]">
            <button
               className=" flex items-center justify-center lg:h-[2.5rem] text-base font-medium px-4 py-4 lg:py-2 rounded-md active:scale-95 transition transform duration-300 border mb-5"
                style={{
                  backgroundColor: Theme.colors.primary,
                  borderColor: Theme.colors.primary,
                  color: Theme.colors.background,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = Theme.colors.background;
                  e.currentTarget.style.color = Theme.colors.primary;
                  e.currentTarget.style.borderColor = Theme.colors.primary;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = Theme.colors.primary;
                  e.currentTarget.style.color = Theme.colors.background;
                  e.currentTarget.style.borderColor = Theme.colors.primary;
                }}
              onClick={() => {
                setIsFiltered(true);
                setCurrentPage(1);
                loadCompanies(0, "filter");
              }}
            >
              Apply Filter
            </button>
         <button
  title="Export to excel"
  className=" flex items-center justify-center lg:h-[2.5rem] text-base font-medium px-4 py-4 lg:py-2 rounded-md active:scale-95 transition transform duration-300 border mb-5"
  disabled={isExporting}
  style={{
    backgroundColor: isExporting ? "#ccc" : Theme.colors.primary,
    borderColor: Theme.colors.primary,
    color: isExporting ? "#666" : Theme.colors.background,
    cursor: isExporting ? "not-allowed" : "pointer",
  }}
  onMouseEnter={(e) => {
    if (!isExporting) {
      e.currentTarget.style.backgroundColor = Theme.colors.background;
      e.currentTarget.style.color = Theme.colors.primary;
      e.currentTarget.style.borderColor = Theme.colors.primary;
    }
  }}
  onMouseLeave={(e) => {
    if (!isExporting) {
      e.currentTarget.style.backgroundColor = Theme.colors.primary;
      e.currentTarget.style.color = Theme.colors.background;
      e.currentTarget.style.borderColor = Theme.colors.primary;
    }
  }}
  onClick={handleExport}
>
  {isExporting ? (
    <>
      <svg
        className="animate-spin mr-2 h-5 w-5 text-inherit"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8z"
        ></path>
      </svg>
      Exporting...
    </>
  ) : (
    "Export to Excel"
  )}
</button>

        </div>
          )}
          {loading ? (
            <div className="flex justify-center items-center h-40">
              <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500"></div>
            </div>
          ) : (
            <div className="w-full h-[500px] overflow-auto border border-gray-200 rounded-md">
              <CompanyTable companies={paginatedData} />
            {/* <TableWithTopScroll companies={paginatedData} /> */}

            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
